module.exports = __webpack_public_path__ + "static/dp_1-adfacd98aa68e74b8b6d1f58c8446edd.jpg";